import React from 'react'
import { Route } from 'react-router-dom'
import { AuditLogRoute } from '../../../../shared/audit/audit-log/audit-log-route'

// /admin/audit-log: the super admin's Audit log (one organization or all);
// /admin/audit-log/entry/:entryID opens one entry's permalink over it, read
// across organizations.
export const LayoutSysAuditLog = () =>
  <Route path="/admin/audit-log/:entry(entry)?/:entryID?" exact>
    <AuditLogRoute base="/admin/audit-log" home="/admin/audit-log" sys />
  </Route>
